import { trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';

import { CHANNELS } from '../utils/constants';
import Link from '../Link';

const PlusLabelDescription = () => {
  const handleOnClick = e => {
    e.preventDefault();
    Mediator.publish(CHANNELS.OPEN_PLUS_VALUE_PROPOSITION_MODAL);
  };

  return (
    <>
      {trans('plus.value.proposition.description')}{' '}
      <strong>
        <Link
          onClick={handleOnClick}
          data-test="plus-value-proposition-open"
          size="medium"
          theme="dark"
        >
          {trans('plus.value.proposition.see-more')}
        </Link>
      </strong>
    </>
  );
};

export default PlusLabelDescription;
